import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router';
import { IDriveContent } from 'src/@types/drive';
import { DriveRequests } from 'src/requests/drive';
import { DriveAddFilePayload } from 'src/requests/drive';
import { QueryKey } from 'src/utils/react-query';

const useAddFileMutation = (folderIdParam?: string) => {
  const { folderId = '' } = useParams();

  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync: addFile, isLoading: isAddFileLoading } = useMutation(
    async ({ file, onUploadProgress }: DriveAddFilePayload) => {
      return DriveRequests.addFile({
        file,
        parent: folderIdParam || folderId,
        onUploadProgress,
      });
    },
    {
      onError: (error) => {
        console.error(error);
        enqueueSnackbar('Failed to upload file', {
          variant: 'error',
        });
      },
      onSuccess: (newFile) => {
        queryClient.setQueryData<IDriveContent[] | undefined>(
          [QueryKey.DRIVE, folderId],
          (contents) => [...(contents || []), newFile],
        );
        queryClient.invalidateQueries([QueryKey.DRIVE]);
      },
    },
  );

  return {
    addFile,
    isAddFileLoading,
  };
};

export default useAddFileMutation;
